export enum StatusKonfiguracjiDyplomowania {
  Przestarzala,
  Aktualna,
  Przyszla,
}
